import $store from '@/store'

/**
 * 토큰 갱신용 인터셉터
 */
export default async (to, from, next) => {
  if (await $store.dispatch('auth/isTokenExpire')) {
    await $store.dispatch('auth/sync')
  }
  next()
}
